import { createTheme } from "@mui/material/styles";
import type { PaletteMode } from "@mui/material";

export function createAppTheme(mode: PaletteMode) {
  const isDark = mode === "dark";

  return createTheme({
    palette: {
      mode,
      primary: {
        main: "#00D1B2",
        dark: isDark ? "#071427" : "#0B1F3A",
        contrastText: "#0B1F3A",
      },
      secondary: { main: "#2F80FF", contrastText: "#ffffff" },
      success: { main: "#00D1B2", contrastText: "#0B1F3A" },
      warning: { main: "#B8F20D", contrastText: "#0B1F3A" },
      background: isDark
        ? { default: "#0B1220", paper: "#111827" }
        : { default: "#F9FAFB", paper: "#ffffff" },
      text: isDark
        ? { primary: "#E5E7EB", secondary: "#9CA3AF" }
        : { primary: "#111827", secondary: "#4B5563" },
      divider: isDark ? "#273247" : "#E5E7EB",
    },
    shape: { borderRadius: 12 },
    typography: {
      fontFamily:
        '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      h1: { fontFamily: '"Space Grotesk", "Inter", sans-serif', fontWeight: 700 },
      h2: { fontFamily: '"Space Grotesk", "Inter", sans-serif', fontWeight: 700 },
      h3: { fontFamily: '"Space Grotesk", "Inter", sans-serif', fontWeight: 700 },
      h4: { fontFamily: '"Space Grotesk", "Inter", sans-serif', fontWeight: 700 },
      h5: { fontFamily: '"Space Grotesk", "Inter", sans-serif', fontWeight: 700 },
      h6: { fontFamily: '"Space Grotesk", "Inter", sans-serif', fontWeight: 700 },
      button: { textTransform: "none", fontWeight: 600 },
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            background: isDark
              ? "radial-gradient(circle at 0% 0%, rgba(0,209,178,0.12), transparent 30%), #0B1220"
              : "radial-gradient(circle at 0% 0%, rgba(0,209,178,0.08), transparent 30%), #F9FAFB",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: {
            border: `1px solid ${isDark ? "#273247" : "#E5E7EB"}`,
            boxShadow: isDark ? "0 8px 24px rgba(0,0,0,0.25)" : "0 8px 24px rgba(11,31,58,0.06)",
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            border: `1px solid ${isDark ? "#273247" : "#E5E7EB"}`,
            boxShadow: isDark ? "0 8px 24px rgba(0,0,0,0.25)" : "0 8px 24px rgba(11,31,58,0.06)",
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: { borderRadius: 12 },
          containedPrimary: {
            boxShadow: "0 0 0 0 rgba(0,209,178,0.3)",
            "&:hover": {
              boxShadow: "0 0 18px rgba(0,209,178,0.28)",
            },
          },
        },
      },
    },
  });
}
